import { GetterTree } from "vuex";
import { RootState } from "../types";
import { GeneralState } from "./types";

export const getters: GetterTree<GeneralState, RootState> = {
  activeCoachmark: (state) => state.activeCoachmark,
  shouldHighlightCourses: (state) => state.activeCoachmark === 2,
  shouldHighlightMyCourses: (state) => state.activeCoachmark === 3,
  shouldHighlightRedeemCode: (state) => state.activeCoachmark === 4,
};
